// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Nunito';
  src: url('Nunito-Regular.ttf') format('truetype');
  font-weight: 400;
}

@font-face {
  font-family: 'Nunito';
  src: url('Nunito-Bold.ttf') format('truetype');
  font-weight: 700;
}

@font-face {
  font-family: 'Nunito';
  src: url('Nunito-Light.ttf') format('truetype');
  font-weight: 300;
}

@font-face {
  font-family: 'Nunito';
  src: url('Nunito-Medium.ttf') format('truetype');
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/assets/fonts/Nunito/Nunito.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,iDAAmD;EACnD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+CAAiD;EACjD,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gDAAkD;EAClD,gBAAgB;AAClB","sourcesContent":["@font-face {\r\n  font-family: 'Nunito';\r\n  src: url('./Nunito-Regular.ttf') format('truetype');\r\n  font-weight: 400;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Nunito';\r\n  src: url('./Nunito-Bold.ttf') format('truetype');\r\n  font-weight: 700;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Nunito';\r\n  src: url('./Nunito-Light.ttf') format('truetype');\r\n  font-weight: 300;\r\n}\r\n\r\n@font-face {\r\n  font-family: 'Nunito';\r\n  src: url('./Nunito-Medium.ttf') format('truetype');\r\n  font-weight: 500;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
